export default __webpack_public_path__ + "static/devices-set-1-ab70d071a476dece4ec2ad5bcb458849.png";